// Exotic dispenser behaviours (MB.7). PURE (ENG-1). A dispenser normally shoots
// arrows / ejects items, but a handful of items make it *act* on the block in
// front instead: bone meal grows a crop, a filled bucket places its fluid (an
// empty bucket scoops one back), a TNT block is placed and lit, shears clip a
// sheep in front, a spawn egg spawns its mob, an armour piece equips onto a
// player standing in front. This owns the item → action classification; the host
// performs the world effect.

export type DispenseAction =
  | 'grow' | 'place_water' | 'place_lava' | 'scoop' | 'ignite_tnt'
  | 'shear' | 'spawn_mob' | 'equip_armor' | 'launch_firework'
  | 'default';

const ARMOR_SUFFIXES = ['_helmet', '_chestplate', '_leggings', '_boots'] as const;

/** The action a dispenser takes when it fires `item`. */
export function dispenseAction(item: string): DispenseAction {
  switch (item) {
    case 'bone_meal': return 'grow';
    case 'water_bucket': return 'place_water';
    case 'lava_bucket': return 'place_lava';
    case 'bucket': return 'scoop';
    case 'tnt': return 'ignite_tnt';
    case 'shears': return 'shear';
    case 'firework_rocket': return 'launch_firework';
  }
  if (item.endsWith('_spawn_egg')) return 'spawn_mob';
  if (ARMOR_SUFFIXES.some((s) => item.endsWith(s))) return 'equip_armor';
  return 'default';
}

/** The mob a spawn egg produces (`pig_spawn_egg` → `pig`), or null for a non-egg. */
export function spawnEggMob(item: string): string | null {
  return item.endsWith('_spawn_egg') ? item.slice(0, -'_spawn_egg'.length) : null;
}

/** Whether an item makes a dispenser act on the world rather than shoot/eject. */
export function isExoticDispense(item: string): boolean {
  return dispenseAction(item) !== 'default';
}
